// ** Custom Components
import Breadcrumbs from "../../../CommonElements/Breadcrumbs/Breadcrumbs";

import React, { Fragment, useEffect, useState } from "react";

import { Card, CardBody, Nav, NavItem, NavLink, TabContent, TabPane, UncontrolledTooltip } from "reactstrap";
import { RefreshCw } from "react-feather";
import classnames from "classnames";
import { useLocation } from 'react-router-dom';


import BulkUpload from "./Bulkupload";
import ManualEntries from "./ManualEntries";

const ClientIndex: React.FC = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const view = queryParams.get('view');

    // Define the initial state outside the component
    let initialActiveTab: string;
    if (localStorage.UserType === "MOS") {
        initialActiveTab = '1';
    } else {
        initialActiveTab = '2';
    }

    // Inside your component
    const [activeTab, setActiveTab] = useState<string>('1');

    useEffect(() => {
        if (view === null) {
            setActiveTab("1")
        } else if (view === "manual") {
            setActiveTab("2")
        }
    }, [view, setActiveTab])

    // Explicitly define the type for the toggle function
    const toggletab: (tab: string) => void = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    // Bumping refreshKey tells the Bulk Upload table to reload its data
    const [refreshKey, setRefreshKey] = useState<number>(0);
    const [isRefreshing, setIsRefreshing] = useState<boolean>(false);
    const handleRefresh = () => {
        if (!isRefreshing) setRefreshKey(prev => prev + 1);
    };

    return (
        <Fragment>
            <TabContent activeTab={activeTab}>
                <TabPane tabId="1"> <Breadcrumbs mainTitle="Bulk Upload" title="Bulk Upload" /></TabPane>
                <TabPane tabId="2"><Breadcrumbs mainTitle="Manual Entries" title="Manual Entries" /></TabPane>
            </TabContent>
            <Card>
                <CardBody>
                    <div className="my-nav d-flex align-items-center">
                        <Nav tabs className="custom-nav-tabs flex-grow-1">
                            <NavItem className="tabcont">
                                <NavLink
                                    className={classnames("nav-link-custom", { active: activeTab === '1' })}
                                    onClick={() => { toggletab('1'); }}
                                >
                                    Bulk Upload
                                </NavLink>
                            </NavItem>
                            <NavItem className="tabcont">

                                <NavLink
                                    className={classnames("nav-link-custom", { active: activeTab === '2' })}
                                    onClick={() => { toggletab('2'); }}
                                >
                                    Manual Entries
                                </NavLink>
                            </NavItem>
                        </Nav>
                        {activeTab === '1' && (
                            <>
                                <div
                                    id="RefreshBulkUpload"
                                    onClick={handleRefresh}
                                    style={{
                                        cursor: isRefreshing ? 'not-allowed' : 'pointer',
                                        opacity: isRefreshing ? 0.5 : 1,
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '5px',
                                        marginLeft: '10px'
                                    }}
                                >
                                    <RefreshCw size={22} color="#355876" />
                                </div>
                                <UncontrolledTooltip placement="top" target="RefreshBulkUpload">
                                    {isRefreshing ? "Refreshing data..." : "Refresh data"}
                                </UncontrolledTooltip>
                            </>
                        )}
                    </div>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <BulkUpload refreshKey={refreshKey} onRefreshingChange={setIsRefreshing} />
                        </TabPane>
                        <TabPane tabId="2">
                            <ManualEntries />
                        </TabPane>
                    </TabContent>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default ClientIndex;
